import { computed, onMounted, ref, watch } from 'vue';
import { getImageLabelList } from '@/api/imageLabel';
import { cloneDeep } from 'lodash';

const defaultImgTagData = {
  id: 0,
  name: '',
};
export default function useImageLabel(props: Recordable) {
  const defaultImgTag = ref(cloneDeep(defaultImgTagData));
  const originDefaultImgTag = ref(cloneDeep(defaultImgTagData));
  const selectImageLabelRef = ref();
  const hasQueryImageLabelList = ref(false);
  const uploadPictureRef = ref();
  const imageLabelList = ref<Recordable>({});
  const uploadPictureWidth = ref('100%');

  const setImgTagId = (file: Recordable) => {
    if (defaultImgTag.value.id && !file.url) {
      file.tagId = defaultImgTag.value.id;
    }
  };

  const hasEnabledImageLabels = computed(() => {
    return imageLabelList.value.length > 0;
  });

  const showSelectImageLabel = computed(() => {
    return props.showUploadRemoveBtn && hasEnabledImageLabels.value;
  });

  const queryImageLabelList = async () => {
    try {
      const res = await getImageLabelList(
        { enable: 1 },
        { page: 1, limit: 20 }
      );
      if (res.status === 200 && res.data?.list) {
        imageLabelList.value = res.data.list;
        // 设置默认图片标签
        defaultImgTag.value =
          imageLabelList.value?.find((item: Recordable) => item.isDefault) ||
          cloneDeep(defaultImgTagData);
        originDefaultImgTag.value = cloneDeep(defaultImgTag.value);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const setDefaultImgTag = () => {
    if (!props.showImageLabel) return;
    if (
      props.showUploadRemoveBtn &&
      originDefaultImgTag.value.id !== defaultImgTag.value.id
    ) {
      defaultImgTag.value = cloneDeep(originDefaultImgTag.value);
    }
  };

  watch(
    () => props.showUploadRemoveBtn,
    (newVal) => {
      if (!props.showImageLabel) return;
      if (newVal && !hasQueryImageLabelList.value) {
        hasQueryImageLabelList.value = true;
        queryImageLabelList();
      }
      if (!newVal) {
        hasQueryImageLabelList.value = false;
      }
    },
    {
      immediate: true,
    }
  );
  onMounted(() => {
    if (!props.showImageLabel) return;
    const uploadPicture = document.querySelector('.upload-list-picture');
    if (uploadPicture) {
      uploadPictureWidth.value = `${uploadPicture.clientWidth}px`;
    }
  });

  return {
    defaultImgTag,
    setImgTagId,
    selectImageLabelRef,
    hasEnabledImageLabels,
    showSelectImageLabel,
    uploadPictureWidth,
    uploadPictureRef,
    setDefaultImgTag,
  };
}
